import { UserGender } from "./types";

export function validateServerError(error: any): Record<'message' | string, string> {
  if(!error.response) {
    return {
      message: error?.message,
    };
  }
  
  const resError = error.response?.data
  if(resError?.statusCode === 400 && Array.isArray(resError.errors)) {
    const firstError = resError.errors.at(0) as any
    
    return {
      message: Object.values(firstError.constraints).at(0) as string,
      property: firstError.property
    };
  }

	return resError;
}

export function getYearsOld(birth: number | undefined) {
  if(!birth) {
    return null;
  }

  if(birth < 100) {
    return birth;
  }

  var today = new Date();
  var birthDate = new Date(birth);
  var age = today.getFullYear() - birthDate.getFullYear();
  var m = today.getMonth() - birthDate.getMonth();
  if(m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
    age--;
  }
  return age;
}

export function getGender(gender: UserGender | undefined) {
  switch (gender) {
    case UserGender.Male:
      return "Male";
    case UserGender.Female:
      return "Female";
    case UserGender.Other:
      return "Not Set";
  }
}

export enum DateType {
  Joined,
  Month,
  Time
}

export function dateFormatter(date: number | string, type: DateType) {
  const datum = new Date(date);
  let options = {};

  switch (type) {
    case DateType.Joined:
      options = { year: 'numeric', month: 'long', day: 'numeric' };
      break;
    case DateType.Month:
      options = { month: 'long', day: 'numeric', weekday: "short" };
      break;
    case DateType.Time:
      options = { hour: '2-digit', minute: '2-digit', hour12: false, };
      return datum.toLocaleTimeString([], options);
  }

  return datum.toLocaleDateString("sv-SE", options)
}

/**
 * @description Add `data-clipboard-exclude` property to node to exclude it from text copying
 * @example ```jsx
 *  <div>
 *   <p>text to copy</p>
 *   <button data-clipboard-exclude>
 *     TEXT_TO_EXCLUDE
 *   </button>
 *  </div>
 * ```
 */
export function copyNodeTextContentToClipBoard(node: HTMLElement) {
  const text = getAllowedNodesText(node)

  return navigator.clipboard.writeText(text)
}

function getAllowedNodesText(node: HTMLElement): string {
  switch(true) {
    // TODO: think about smart filter as argument instead of data-attribute
    case !!node.dataset.clipboardExclude:
      return ''
    case !node.children.length:
      return node.textContent ?? ''
    default:
      return Array.from(node.children)
        .map(child => getAllowedNodesText(child as HTMLElement))
        .join('\n')
        .replaceAll(/\n{3,}/g, '\n'.repeat(2))
  }
}
